"use strict";

exports.__esModule = true;
exports.getSeries = void 0;
var _react = _interopRequireDefault(require("react"));
var _ScatterPlotChart = require("../common/AggregateMetricCharts/ScatterPlotChart");
var _helper = require("./helper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var getSeries = exports.getSeries = function getSeries(_ref) {
  var data = _ref.data,
    measureChartSeries = _ref.measureChartSeries,
    interval = _ref.interval,
    scatterPlotRadius = _ref.scatterPlotRadius;
  return measureChartSeries.map(function (measureData) {
    var measureName = measureData.id.split(".")[1];
    var formattedData = getFormattedData(data, measureName, interval, measureData.color);
    return {
      unit: measureData.name,
      data: formattedData,
      getXValue: function getXValue(item) {
        return Date.parse(item.key);
      },
      getYValue: function getYValue(item) {
        return item.value;
      },
      getTooltip: function getTooltip(item) {
        return (0, _helper.getTooltip)(item, measureData.name);
      },
      render: function render(props) {
        return /*#__PURE__*/_react["default"].createElement(_ScatterPlotChart.ScatterPlotChart, _extends({}, props, {
          radius: scatterPlotRadius
        }));
      }
    };
  });
};
var getFormattedData = function getFormattedData(data, measureName, interval, color) {
  var formattedData = data.reduce(function (t, _ref2) {
    var measures = _ref2.measures,
      timestamp_end = _ref2.timestamp_end;
    if (Date.parse(timestamp_end) >= interval.startMillis && Date.parse(timestamp_end) <= interval.endMillis) {
      //Remove all null values
      if (measures && measures[measureName] !== null) {
        return t.concat({
          key: timestamp_end,
          unit: "OTHER",
          color: color || "#68ccca",
          value: measures[measureName]
        });
      }
    }
    return t;
  }, []);
  formattedData.sort(function (a, b) {
    var keyA = new Date(a.key),
      keyB = new Date(b.key);
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
    return 0;
  });
  return formattedData;
};